module.exports = __webpack_public_path__ + "img/stock6.26b608ee.png";